import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import FeaturePlatform from './Pages/FeaturePlatform';
import Dashboard from './Pages/Dashboard';
import FAQs from './Pages/FAQs';
import ContactUs from './Pages/ContactUs';
import Deposit from './Pages/Deposit';
import Credit from './Pages/Credit';
import Promotions from './Pages/Promotions';
import AdminLogin from './Pages/AdminLogin';
import { ConfigProvider } from "antd";
import Profile from './Pages/Profile';
import Transaction from './Pages/Transactions';
import Sessions from './Pages/Sessions';
import SocialMedia from './Pages/SocialMedia';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const loggedIn = localStorage.getItem('isLoggedIn');
        setIsAuthenticated(loggedIn === 'true');
        console.log('Logged In:', loggedIn);
    }, []);

    useEffect(() => {
        console.log('Authenticated state:', isAuthenticated);
    }, [isAuthenticated]);

    return (
        <Router>
            <Routes>
                <Route path="/Admin-Login" element={<AdminLogin setIsAuthenticated={setIsAuthenticated} />} />
                <Route
                    path="/"
                    element={isAuthenticated ? <Navigate to="/Dashboard" /> : <Navigate to="/Admin-Login" />}
                />
                <Route element={<ConfigProvider
                    theme={{
                        token: {
                            colorPrimary: "#1E90FF",
                            colorBgContainer: "#0B1120",
                            colorBgLayout: "#0B1120",
                            colorText: "#ffffff",
                            colorTextSecondary: "#b0c4de",
                            colorBorder: "rgba(30, 144, 255, 0.12)",
                        },
                        components: {
                            Menu: {
                                darkItemSelectedBg: "#1E90FF",
                                darkItemHoverBg: "rgba(30, 144, 255, 0.3)",
                            },
                            Layout: {
                                headerBg: "#101828",
                                siderBg: "#0B1120",
                                bodyBg: "#0B1120",
                            },
                        },
                    }}>
                    <MainLayout />
                </ConfigProvider>}>
                    <Route path="Dashboard" element={<Dashboard />} />
                    <Route path="Profile" element={<Profile />} />
                    <Route path="FeaturePlatform" element={<FeaturePlatform />} />
                    <Route path="Transactions" element={<Transaction />} />
                    <Route path="Sessions" element={<Sessions />} />
                    <Route path="SocialMedia" element={<SocialMedia />} />
                    <Route path="FAQs" element={<FAQs />} />
                    <Route path="ContactUs" element={<ContactUs />} />
                    <Route path="Deposit" element={<Deposit />} />
                    <Route path="Credit" element={<Credit />} />
                    <Route path="Promotions" element={<Promotions />} />
                </Route>

                {/* Catch-all for non-existing routes */}
                <Route path="*" element={<Navigate to={isAuthenticated ? "/Dashboard" : "/Admin-Login"} />} />
            </Routes>
        </Router>
    );
}

export default App;
